<router-outlet />
<footer>
  <app-main-footer></app-main-footer>
</footer>